import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'staffingRatio', standalone: true })
export class StaffingRatioPipe implements PipeTransform {
    transform(value: string): string {
        return value ? `1:${value}` : '';
    }
}
